










import StartPageSlider from '../../parts/slider/StartPageSlider.vue';
import AppPicture from '@/uikit/components/AppPicture/AppPicture.vue';
import {
  LayoutConfig,
  LayoutDataSet,
} from '@/uikit/components/AppDefaultLayout/types/LayoutTypes';

export default {
  components: { AppPicture, StartPageSlider },
  props: {
    cfg: {
      type: Object as () => LayoutConfig['content']['startPage']['sections']['photoGallery'],
      required: true,
    },
    data: {
      type: Array as () => LayoutDataSet['photoGallery'],
    },
  },
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/uikit/components/AppDefaultLayout/components/sections/photoGallery/PhotoGallery.vue